import React from "react";
import headerBg from "./assets/picOne.png";

const OtherServices = () => {
  return (
    <div className="other-services-page">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Other Services</h1>
          <p className="subtitle">
            Providing specialised technical support and scientific services to industry, laboratories and institutions across Malawi.
          </p>
        </div>
      </section>

      {/* === Cards Section === */}
      <section className="cards-section">
        <div className="card">
          <h2>Industrial Research, Training and Consultancy Unit</h2>
          <p>
            The MBS offers client-based industrial research training and consultancies in areas such as product development,
            safety, hygiene and environmental protection.
          </p>
        </div>

        <div className="card">
          <h2>Instrumentation Support Services</h2>
          <p>
            The MBS provides installation, repair and maintenance services of scientific equipment and instruments.
          </p>
        </div>

        <div className="card">
          <h2>Computer Based Instrument Registry</h2>
          <p>
            The MBS registers scientific equipment in government and other scientific institutions to ensure maximum use of
            instruments resource in the country. It also provides information to scientific institutions on addresses of
            suppliers of equipment in the country and abroad.
          </p>
        </div>
      </section>

      {/* === CSS === */}
      <style>{`
        .other-services-page {
          font-family: Arial, sans-serif;
          color: #333;
        }

       .about-header {
          background-image: url(${headerBg});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }

           .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          border-radius: 12px;
        }

        .page-title {
          font-size: 2.1rem;
          font-weight: 600;
          margin-bottom: 8px; /* added spacing */
        }

        .subtitle {
          font-size: 0.95rem;
          line-height: 1.4;
          margin-bottom: 5px;
        }

        .cards-section {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 22px;
          padding: 40px 10% 90px 10%;
        }

        .card {
          background: #ffffff;
          padding: 18px 20px 140px 20px;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
          transition: 0.3s ease;
        }

        .card h2 {
          color: #ff6600;
          font-size: 0.9rem; /* smaller title */
          margin-bottom: 8px; /* space between title and description */
          padding-right: 20px;
          font-weight: 600;
        }

        .card p {
          line-height: 1.5;
          font-size: 0.8rem; /* reduced paragraph font */
        }

        .card:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.13);
        }

        @media (max-width: 768px) {
          .page-title { font-size: 1.6rem; }
          .subtitle { font-size: 0.85rem; }
        }
      `}</style>
    </div>
  );
};

export default OtherServices;
